
Object.defineProperty(exports, '__esModule', {
  value: true
});
Object.defineProperty(exports, 'BarGauge', {
  enumerable: true,
  get: function get() {
    return _BarGauge.BarGauge;
  }
});

var _BarGauge = require('./BarGauge');
